export default "__VITE_ASSET__DB0lq2YE__"